import React, { useState, useEffect, useCallback } from 'react';
import AthenaConsole, { ChatEntry } from './AthenaConsole';

const AthenaDrawer: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [chat, setChat] = useState<ChatEntry[]>([]);

  const onKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key === 'Escape') setOpen(false);
  }, []);

  useEffect(() => {
    if (!open) return;
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onKeyDown]);

  const drawerWidth = 'min(92vw, 420px)';

  return (
    <>
      <button
        onClick={() => setOpen(!open)}
        style={{
          position: 'fixed',
          bottom: '16px',
          left: '16px',
          zIndex: 3000,
          background: 'transparent',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
        }}
      >
        <img
          src="/athena-avatar.png"
          alt="Athena"
          style={{
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            border: '2px solid #3a86ff',
            boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
          }}
        />
      </button>

      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          height: '100dvh',
          width: drawerWidth,
          backgroundColor: '#111',
          color: '#fff',
          borderRight: '1px solid #444',
          zIndex: 2999,
          transform: open ? 'translateX(0)' : 'translateX(-100%)',
          transition: 'transform 0.3s ease-in-out',
          boxShadow: '2px 0 24px rgba(0,0,0,0.45)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          style={{
            textAlign: 'center',
            padding: '1rem',
            borderBottom: '1px solid #333',
          }}
        >
          <h3 style={{ color: '#80b0ff', margin: 0 }}>Athena Console</h3>
        </div>

        <div style={{ flex: 1, minHeight: 0 }}>
          <AthenaConsole chat={chat} setChat={setChat} />
        </div>
      </div>
    </>
  );
};

export default AthenaDrawer;
